import React, { Component, PropTypes } from 'react';

import forEach from 'lodash/forEach';
import Image from '../../components/image/image';
import {Link} from 'react-router';

import ThreeImages from '../../components/threeimages/threeimages';
import Hof from '../../components/hof/hof';
//Form elements for newsletter
import Form from '../../components/form/form';
import InputText from '../../components/form/input/text';
import InputSubmit from '../../components/form/input/submit';

export default class PageContent extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			waiting: false,
			formErrors: {},
			submitted: false,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state !== nextState
		);
	}

	componentDidUpdate() {
		if (document.querySelector('.page__section__item__text__manchet')) {
			let h = document.querySelector('.page__section__item__text__manchet').clientHeight;

			forEach(document.querySelectorAll('.page__section__item__text__manchet--fill'), function(fill) {
				fill.style.height = h + 'px';
			});
		}
	}

	componentDidMount() {
		if (document.querySelector('.page__section__item__text__manchet')) {
			let h = document.querySelector('.page__section__item__text__manchet').clientHeight;

			forEach(document.querySelectorAll('.page__section__item__text__manchet--fill'), function(fill) {
				fill.style.height = h + 'px';
			});
		}
	}

	render() {
		let uid = 'page-content';

		let content = this.props.content;

		return (
			content.type == 2 && (
				this.twoColumns(content, uid)
			) || content.type == 3 && (
				this.threeColumns(content, uid)
			) || content.type == 'seperator' && (
				<div key={uid} className='page__splitter span5 pixel-pattern'></div>
			) || content.type == 'images' && (
				<ThreeImages className='page__section' key={uid} imgone={content.image1} imgtwo={content.image2} imgthree={content.image3} browser={this.props.browser} />
			) || content.type == 'image' && (
				<div key={uid} className='page__section page__section--force-full span14'>
					<Image img={content.image} span='span14' alt='' browser={this.props.browser} />
				</div>
			) || content.type == 'hof' && (
				<Hof key={uid} browser={this.props.browser} />
			) || null
		);
	}

	twoColumns(content, uid) {
		let columnOne = [];
		let columnTwo = [];

		forEach(content, function(con, key) {
			if (key.indexOf('column1') > -1) {
				if (key == 'column1') {
					columnOne['text'] = con;
				} else {
					columnOne[key.replace('column1','')] = con;
				}
			} else if (key.indexOf('column2') > -1) {
				if (key == 'column2') {
					columnTwo['text'] = con;
				} else {
					columnTwo[key.replace('column2','')] = con;
				}
			}
		});

		let hasAHead = false;
		let hasManchet = false;

		if (columnOne.SubHeadline !== '' || columnTwo.SubHeadline !== '') {
			hasAHead = true;
		}

		let multiple = '';

		if (columnOne.Headline !== '' && columnTwo.Headline !== '') {
			multiple = ' page__section__two-column--multiple';
		}

		let hasAny = false;
		let borderClass = '';

		if (columnOne.Headline !== '' || columnTwo.Headline !== '') {
			hasAny = true;
			borderClass = ' page__section__content__content--border';
		}

		return(
			<section key={uid} className='page__section page__section__two-wrap'>
				<div className={'page__section__two-column span7 span14-mobile' + multiple}>
					{columnOne.Headline != '' && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
					)}
					{columnOne.Headline != '' && (
					<h1 className='page__section__head'>{columnOne.Headline}</h1>
					)}
					<div className={'page__section__content__content' + borderClass}>
						{this.renderColumn(columnOne, 'span7 span14-mobile page__section__item--border', true, hasAHead, hasManchet)}
					</div>
				</div>
				<div className={'page__section__two-column span7 span14-mobile' + multiple}>
					{columnTwo.Headline != '' && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
					)}
					{columnTwo.Headline != '' && (
					<h1 className='page__section__head'>{columnTwo.Headline}</h1>
					) || hasAny && (
					<div className='page__section__head page__section__head--hide-left hide-mobile'></div>
					)}
					<div className={'page__section__content__content' + borderClass}>
					{this.renderColumn(columnTwo, 'span7 span14-mobile', true, hasAHead, hasManchet)}
					</div>
				</div>
			</section>
		)
	}

	threeColumns(content, uid) {
		let columnOne = [];
		let columnTwo = [];
		let columnThree = [];

		forEach(content, function(con, key) {
			if (key.indexOf('column1') > -1) {
				if (key == 'column1') {
					columnOne['text'] = con;
				} else {
					columnOne[key.replace('column1','')] = con;
				}
			} else if(key.indexOf('column2') > -1) {
				if (key == 'column2') {
					columnTwo['text'] = con;
				} else {
					columnTwo[key.replace('column2','')] = con;
				}
			} else if (key.indexOf('column3') > -1) {
				if (key == 'column3') {
					columnThree['text'] = con;
				} else {
					columnThree[key.replace('column3','')] = con;
				}
			}
		});

		let hasAHead = false;
		let borderClass = '';
		let hasManchet = false;

		if (columnOne.SubHeadline !== '' || columnTwo.SubHeadline !== '' || columnThree.SubHeadline !== '') {
			hasAHead = true;

			if (this.props.isHof !== 1) {
				borderClass = ' page__section__content__content--border';
			}
		}

		if (content.head !== '') {
			borderClass = ' page__section__content__content--border';
		}

		if (columnOne.Manchet !== '' || columnTwo.Manchet !== '' || columnThree.Manchet !== '') {
			hasManchet = true;
		}



		return(
			<section key={uid} className='page__section'>
				<div className='page__section__content'>
					{content.head != '' && this.props.isHof != 1 && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
					)}
					{content.head != '' && (
					<h1 className='page__section__head'>{content.head}</h1>
					)}
					<div className={'page__section__content__content' + borderClass}>
						<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
						{this.renderColumn(columnOne, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet)}
						{this.renderColumn(columnTwo, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet)}
						{this.props.isHof == 1 && (
							this.renderColumn(columnThree, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet)
						) || (
							this.renderColumn(columnThree, 'span4 span7-tablet span14-mobile clear-tablet', false, hasAHead, hasManchet)
						)}
						<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
					</div>
				</div>
			</section>
		)
	}

	renderColumn(column, extraClass, filler, hasAHead, hasManchet) {
		return(
			column.Type == 'TEXT' && (
				this.renderText(column, extraClass, filler, hasAHead, hasManchet)
			) || column.Type == 'IMAGE' && (
				this.renderImage(column, extraClass, filler, hasAHead, hasManchet)
			) || column.Type == 'LINK' && (
				this.renderLinks(column, extraClass, filler, hasAHead, hasManchet)
			) || column.Type == 'NEWSLETTER' && (
				this.renderNewsletter(column, extraClass, filler, hasAHead, hasManchet)
			) || null
		)
	}

	renderNewsletter(column, extraClass, filler, hasAHead) {
		let className = 'page__section__item ' + extraClass;
		return(
			<div className={className}>
				{filler && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
				)}
				{column.SubHeadline != ''&& (
				<h2 className='page__section__sub-head'>{column.SubHeadline}</h2>
				) || hasAHead && (
				<div className='page__section__sub-head'></div>
				)}
				{!this.state.submitted && (
				<Form className='page__section__item__newsletter span4 span6-tablet span14-mobile' getRefs={() => this.getRefs()} newsletterForm={true} method='post' action={'/api/newsletter'} ref='form' onSubmit={this.onFormSubmit.bind(this)}>
					<InputText name='name' ref='name' className='page__section__item__newsletter__input span3 span5-tablet span10-mobile' type='text' placeholder='Full Name'/>
					<span />
					<InputText name='email' ref='email' className='page__section__item__newsletter__input span3 span5-tablet span10-mobile' type='email' placeholder='Email'/>
					<InputSubmit className='page__section__item__newsletter__submit button-go' name='Subscribe' value='Subscribe' waiting={this.state.waiting} />
				</Form>
				) || (
				<p className='page__section__item__text'>{column.NewsletterMessage}</p>
				)}
			</div>
		)
	}

	onFormSubmit(promise) {
		if (this.refs.form && this.refs.form.serialize) {
			this.setState({ ...this.state, waiting: true });

			promise
			.then((resp) => {
				this.setState({
					...this.state,
					submitted: true,
					waiting: false,
					formErrors: {},
				});
			})
			.catch((resp) => {
				this.setState({
					...this.state,
					waiting: false,
					formErrors: (typeof resp.data.errors === 'object') ? resp.data.errors : {},
				});
			});
		}
	}

	getRefs() {
		return this.refs;
	}

	renderLinks(column, extraClass, filler, hasAHead, hasManchet) {
		let links = [];

		for (var i = 1; i < 5; i++) {
			let key = 'Link' + i;
			if (column[key]) {
				let link = {
					link: column[key],
					text: column[key+'_name'],
					alt: column[key+'_title'],
				};
				links.push(link)
			}
		}

		let className = 'page__section__item ' + extraClass;

		return(
			<div className={className}>
				{filler && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
				)}
				{column.SubHeadline != '' && (
				<h2 className='page__section__sub-head'>{column.SubHeadline}</h2>
				) || hasAHead && (
				<div className='page__section__sub-head'></div>
				)}
				{hasManchet && (
				<p className='page__section__item__text__manchet--fill'></p>
				)}
				<ul className='page__section__item__links span4 span6-tablet span14-mobile'>
				{links.map((link, i) => this.renderLink(link, i))}
				</ul>
			</div>
		);
	}

	renderLink(link, i) {
		let uid = 'link' + i;

		if (link.link.indexOf(window.location.hostname) > -1) {
			let url = link.link.replace(/^.*\/\/[^\/]+/, '');

			return(
				<li key={uid} className='page__section__item__links__link'>
					<Link to={url} title={link.alt} alt={link.alt}>{link.text}</Link>
				</li>
			);
		} else {
			return(
				<li key={uid} className='page__section__item__links__link'>
					<a href={link.link} title={link.alt} alt={link.alt}>{link.text}</a>
				</li>
			);
		}
	}

	renderImage(column, extraClass, filler, hasAHead, hasManchet) {
		let className = 'page__section__item ' + extraClass;
		return(
			<div className={className}>
				{filler && (
					<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
				)}
				{column.SubHeadline != ''&& (
				<h2 className='page__section__sub-head'>{column.SubHeadline}</h2>
				) || hasAHead && (
				<div className='page__section__sub-head'></div>
				)}
				{hasManchet && (
				<p className='page__section__item__text__manchet--fill'></p>
				)}
				<Image className='page__section__item__image span4 span6-tablet span14-mobile' img={column.Image} span='span14' alt='' browser={this.props.browser} />
			</div>
		)
	}

	renderText(column, extraClass, filler, hasAHead, hasManchet) {
		let className = 'page__section__item ' + extraClass;

		let extraHtml = '';

		if (column.Manchet != '' && hasManchet) {
			extraHtml = '<p class="page__section__item__text__manchet">' + column.Manchet + '</p>';
		} else if (hasManchet){
			extraHtml = '<p class="page__section__item__text__manchet--fill"></p>';
		}

		if (this.props.isHof == 1 && column.SubHeadline != '') {
			className += ' page__section__item--hof'
		}



		if (column.SubHeadline != '' || column.text != '') {
			return(
				<div className={className}>
					{filler && (
						<div className='page__section__fill span1 hide-tablet hide-mobile'></div>
					)}
					{column.SubHeadline != '' && this.props.isHof == 1 && (
					<h2 className='page__section__sub-head page__section__sub-head--hof'>{column.SubHeadline}</h2>
					) || column.SubHeadline !== '' && (
					<h2 className='page__section__sub-head'>{column.SubHeadline}</h2>
					) || hasAHead && (
					<div className='page__section__sub-head'></div>
					)}
					<div className='page__section__item__text span4 span6-tablet span14-mobile' dangerouslySetInnerHTML={{__html: extraHtml  + column.text}}>
					</div>
				</div>
			)
		} else {
			return false;
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/containers/page/content.js
 **/